import React from 'react'
import { useLocation } from 'react-router-dom'
import { useAuth, useModals, usePage } from 'hooks'
import InviteUsersModal from './members/InviteUsersModal'
import OrganizationHeader from './OrganizationHeader'

export default function SettingsHeader() {
  const { userIsCurrentOrgAdmin } = useAuth()
  const { openModal } = useModals()
  const { header } = usePage()
  const location = useLocation()

  const headerSections = header?.settingsSections

  return (
    <OrganizationHeader
      sections={headerSections}
      sectionsValue={location.pathname}
      button={
        userIsCurrentOrgAdmin
          ? { onClick: () => openModal(InviteUsersModal), text: '+ Invite People' }
          : null
      }
    />
  )
}
